var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgNewFolder(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.04004 11.5003C7.76671 11.5003 7.54004 11.2737 7.54004 11.0003V7.66699C7.54004 7.39366 7.76671 7.16699 8.04004 7.16699C8.31337 7.16699 8.54004 7.39366 8.54004 7.66699V11.0003C8.54004 11.2737 8.31337 11.5003 8.04004 11.5003Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M9.66683 9.83301H6.3335C6.06016 9.83301 5.8335 9.60634 5.8335 9.33301C5.8335 9.05967 6.06016 8.83301 6.3335 8.83301H9.66683C9.94016 8.83301 10.1668 9.05967 10.1668 9.33301C10.1668 9.60634 9.94016 9.83301 9.66683 9.83301Z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.3335 15.1663H4.66683C1.72683 15.1663 0.833496 14.273 0.833496 11.333V4.66634C0.833496 1.72634 1.72683 0.833008 4.66683 0.833008H5.66683C6.8335 0.833008 7.20016 1.21301 7.66683 1.83301L8.66683 3.16634C8.88683 3.45967 8.92016 3.49967 9.3335 3.49967H11.3335C14.2735 3.49967 15.1668 4.39301 15.1668 7.33301V11.333C15.1668 14.273 14.2735 15.1663 11.3335 15.1663ZM4.66683 1.83301C2.28683 1.83301 1.8335 2.28634 1.8335 4.66634V11.333C1.8335 13.713 2.28683 14.1663 4.66683 14.1663H11.3335C13.7135 14.1663 14.1668 13.713 14.1668 11.333V7.33301C14.1668 4.95301 13.7135 4.49967 11.3335 4.49967H9.3335C8.48016 4.49967 8.20016 4.20634 7.86683 3.76634L6.86683 2.43301C6.52016 1.97301 6.42016 1.83301 5.66683 1.83301H4.66683Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNewFolder);
export default __webpack_public_path__ + "static/media/NewFolder.5d8b3390a545c2d05ffbd3d79bbb8ba8.svg";
export { ForwardRef as ReactComponent };